import { Grid } from '@material-ui/core';
import TabComponent from '../../../Core/Controls/Tabs';
import React, { useEffect, useState } from 'react';
import { getVehicleInspectionsStatusList } from '../../../Core/Service/vehicleInspectionByStatus-service';
import VehicleInspectionGrid from './InspectionbyStatusGrid';

const VehicleInspectionStatus = (props) => {
    const [statusList, setStatusList] = useState([]);
    const urlParams = new URLSearchParams(props?.location?.search);
    const techStatusId = urlParams.get("statusId");
    const technicianUserID = urlParams.get("technicianUserID");
    const [selectedIndex, setSelectedIndex] = useState(0);

    useEffect(() => {

        if (statusList.length > 0 && techStatusId) {
            const index = statusList.findIndex(q => q.id == parseInt(techStatusId));
            setSelectedIndex(index >= 0 ? index : 0);
        }
    }, [statusList, techStatusId])

    useEffect(() => {
        let fetchData = async () => {
            let res = await getVehicleInspectionsStatusList();
            if (res.success) {
                setStatusList(res.data.list);
            }
        };
        fetchData();
    }, []);

    const insideTabs = statusList.map((q) => ({ label: `${q.name}`, body: <VehicleInspectionGrid statusId={q.id} /> }));
    return (
        <Grid container item>
            <Grid item style={{ height: '100%', width: '100%' }}>
                <TabComponent tabList={insideTabs} selectedIndex={selectedIndex} />
            </Grid>
        </Grid>
    );
};

export default VehicleInspectionStatus;
